module.exports = {preferredDeliveryMethod:'None',partyInfo:[{partyTypeCd:'InsuredParty',nameInfo:{nameTypeCd:'InsuredName'}}]}